jQuery(function ($) {
    var $window = $(window);
    var $buttonTop = $('.button-top');
    var scrollTimer;

    $buttonTop.on('click', function () {
        $('html, body').animate({
            scrollTop: 0,
        }, 400);
    });

    // scroll to top when going to the next page product archive
    $(document).on('click', 'ul.page-numbers a.page-numbers', function () {
        $('html, body').animate({
            scrollTop: 0,
        }, 400);
    });

    // scroll to top when going to the next page recepten archive
    $(document).on('click', 'div.facetwp-pager a.facetwp-page', function () {
        $('html, body').animate({
            scrollTop: 0,
        }, 400);
    });

    $window.on('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
            if ($window.scrollTop() > 100) {
                $buttonTop.addClass('button-top-visible');
            } else {
                $buttonTop.removeClass('button-top-visible');
            }
        }, 250);
    });
})